import { render, staticRenderFns } from "./RealEstateAcquisitionTax.vue?vue&type=template&id=19c6d4b6&scoped=true&"
import script from "./RealEstateAcquisitionTax.vue?vue&type=script&lang=js&"
export * from "./RealEstateAcquisitionTax.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateAcquisitionTax.vue?vue&type=style&index=0&id=19c6d4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c6d4b6",
  null
  
)

export default component.exports